import React, { FC } from 'react';
import { SkeletonGroup, SkeletonRectangle, Layout, Cell } from '@wix/design-system';
import { RELATED_ITEM_HEIGHT } from '../constants';

type RelatedItemsSkeletonProps = {
  onClose: () => void;
};

export const RelatedItemsSkeleton: FC<RelatedItemsSkeletonProps> = ({ onClose }) => {
  return (
    <SkeletonGroup skin="light" dataHook="related-items-skeleton">
      <Layout>
        <Cell span={3}>
          <SkeletonRectangle height={RELATED_ITEM_HEIGHT} width="100%" />
        </Cell>
        <Cell span={3}>
          <SkeletonRectangle height={RELATED_ITEM_HEIGHT} width="100%" />
        </Cell>
        <Cell span={3}>
          <SkeletonRectangle height={RELATED_ITEM_HEIGHT} width="100%" />
        </Cell>
        <Cell span={3}>
          <SkeletonRectangle height={RELATED_ITEM_HEIGHT} width="100%" />
        </Cell>
      </Layout>
    </SkeletonGroup>
  );
};
